import useTranslation from "../../client/hooks/useTranslation";
import { Button } from "../../client/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../../client/components/ui/dialog";
import { useUiMode } from "../mode/useUiMode";
import { useLiteData } from "../data/LiteDataProvider";

/**
 * Modale de lancement : présente le Lite aux utilisateurs existants (qui ont
 * déjà des trades ou des comptes) et montre comment revenir en Advanced.
 * Un nouvel inscrit, lui, passe par l'onboarding.
 */
export function LiteIntroModal() {
  const t = useTranslation().lite.intro;
  const { introSeen, markIntroSeen, canUseAdvanced } = useUiMode();
  const { trades, accounts, loading } = useLiteData();
  const existingUser = trades.length > 0 || accounts.length > 0;
  const open = !loading && existingUser && !introSeen;

  return (
    <Dialog open={open} onOpenChange={o => { if (!o) markIntroSeen(); }}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display text-lg">{t.title}</DialogTitle>
          <DialogDescription className="leading-relaxed">{t.lead}</DialogDescription>
        </DialogHeader>
        <div className="rounded-xl bg-muted/60 p-4 space-y-2.5 text-sm">
          {t.points.map((p, i) => (
            <div key={p} className="flex gap-3">
              <span className="w-5 h-5 rounded-full bg-primary/15 text-primary text-[11px] font-semibold grid place-items-center shrink-0">{i + 1}</span>
              <span>{p}</span>
            </div>
          ))}
        </div>
        {canUseAdvanced ? (
          <div className="rounded-xl border border-primary/30 bg-primary/5 p-4 text-sm">
            <div className="font-medium">{t.backTitle}</div>
            <p className="text-muted-foreground mt-1">{t.backText}</p>
          </div>
        ) : (
          <p className="text-xs text-muted-foreground">{t.freeNote}</p>
        )}
        <DialogFooter>
          <Button onClick={markIntroSeen}>{t.cta}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
